// A best per task against the person's own history, never against anyone else.
import type { Day } from "../lib/types";
import { dayMonth } from "../lib/days";
import { Glyph } from "./Glyph";

export interface PersonalBestProps {
  task: string;
  taskName?: string | null;
  /** What they just made (null before a submit). */
  made?: number | null;
  /** Their best before this session. */
  best: { qty: number; day: Day } | null;
}

export function isPersonalBest(made: number | null | undefined, best: { qty: number } | null): boolean {
  return made != null && made > 0 && (!best || made > best.qty);
}

export function PersonalBest({ task, taskName, made, best }: PersonalBestProps) {
  const isNew = isPersonalBest(made, best);
  const name = taskName ? `${task} ${taskName}` : task;
  let big: string, sub: string;
  if (isNew) {
    big = `New personal best: ${made}`;
    sub = best ? `on ${name}, beating your ${best.qty} on ${dayMonth(best.day)}` : `Your first ${name} logged`;
  } else if (best) {
    big = `Your best on ${task}: ${best.qty}`;
    sub = `${dayMonth(best.day)}${made != null ? `. Today ${made}` : ""}`;
  } else {
    big = `First time on ${task}`;
    sub = "Whatever you make today is your best so far";
  }
  return (
    <div className={`pb${isNew ? " pb--new" : ""}`} data-testid="personal-best" data-new={isNew}>
      <span className="pb__mark"><Glyph name="star" size={20} /></span>
      <div><div className="pb__big">{big}</div><div className="pb__sub">{sub}</div></div>
    </div>
  );
}
